import { Check } from "lucide-react";
import { money } from "../../lib/finance";

/** What the entry form shows once its entry has saved. */
export default function ExpenseSaved({ heading, amount, currency, detail, recurringError, pendingConfirmation = false, onAddAnother }: {
  heading: string;
  amount: number;
  currency: string | undefined;
  /** The payee of a loan, or the title and category of anything else. */
  detail: string;
  /** Set when the entry saved but the recurring bill asked for alongside it did not. */
  recurringError: string;
  /** The entry is safely kept locally, but the server has not confirmed it yet. */
  pendingConfirmation?: boolean;
  onAddAnother?: () => void;
}) {
  return (
    <div className="expense-success" role="status">
      <span>
        <Check size={32} />
      </span>
      <h3>{pendingConfirmation ? "Saved on this device." : heading}</h3>
      <strong>{money(amount, currency)}</strong>
      <p>{detail}</p>
      <small>
        {pendingConfirmation
          ? "Your entries will sync automatically when you’re online. You can keep adding transactions."
          : "Saved."}
      </small>
      {onAddAnother && <button className="primary-button" onClick={onAddAnother}>Add another transaction</button>}
      {recurringError && (
        <p className="form-error" role="alert">
          This entry saved, but the recurring bill wasn't created: {recurringError}. You can still add it from the Bills screen, based on this transaction.
        </p>
      )}
    </div>
  );
}
